module.exports = __webpack_public_path__ + "img/banner_generic_left.c3bb8cbd.jpg";